import clamp from './clamp';

export default function withOpacity(hex: `#${string}`, opacity: number): string {
  const hexOpacity = clamp(+Math.round(opacity * 255).toString(16), 0, 255);
  return `${hex}${hexOpacity}`;
}
